import FeatureFlagWrapper from "components/_common/FeatureFlagWrapper";
import React from "react";
import { Route, Switch } from "react-router-dom";
import ManualStockEntryPage from "pages/warehouse/ManualStockEntryPage";
import LogHoursPage from "pages/warehouse/LogHoursPage";

const WarehouseRouter = () => {
  return (
    <Switch>
      <FeatureFlagWrapper feature="billingEngine">
        <>
          <Route exact path="/warehouse/warehouse-stock" component={ManualStockEntryPage} />
          <Route exact path="/warehouse/log-hours" component={LogHoursPage} />
        </>
      </FeatureFlagWrapper>
    </Switch>
  );
};

export default WarehouseRouter;
